import ApiService from "@/common/api.service";

const PATH = "stock/revisions";

export const GET_STOCK_REVISIONS = "getStockRevisions";
export const GET_STOCK_REVISION = "getStockRevision";
export const GET_STOCK_REVISION_STATUSES = "getStockRevisionStatuses";
export const GET_STOCK_REVISION_WAREHOUSE_STATE = "getStockRevisionWarehouseState";
export const START_STOCK_REVISION = "startStockRevision";
export const UPDATE_STOCK_REVISION = "updateStockRevision";
export const DELETE_STOCK_REVISION = "deleteStockRevision";
export const GET_STOCK_REVISION_COUNT_SHEET = "getStockRevisionCountSheet";
export const GET_STOCK_REVISION_SUMMARY = "getStockRevisionSummary";
export const GET_STOCK_REVISION_WARNINGS = "getStockRevisionWarnings";
export const SAVE_STOCK_REVISION_COUNTS = "saveStockRevisionCounts";
export const ACCEPT_STOCK_REVISION_DEFAULT_COUNTS = "acceptStockRevisionDefaultCounts";
export const FINALIZE_STOCK_REVISION = "finalizeStockRevision";
export const REOPEN_STOCK_REVISION = "reopenStockRevision";
export const REOPEN_LATEST_STOCK_REVISION = "reopenLatestStockRevision";
export const GET_STOCK_REVISION_ITEM_LOTS = "getStockRevisionItemLots";
export const SAVE_STOCK_REVISION_ITEM_LOTS = "saveStockRevisionItemLots";

const actions = {
  [GET_STOCK_REVISIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_REVISION](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_REVISION_STATUSES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("stock/revision-statuses")
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_REVISION_WAREHOUSE_STATE](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/warehouse-state`, params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [START_STOCK_REVISION](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_REVISION](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_REVISION](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${id}`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_REVISION_COUNT_SHEET](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/${payload.id}/count-sheet`, payload.params || {})
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_REVISION_SUMMARY](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/${payload.id}/summary`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_REVISION_WARNINGS](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/${id}/warnings`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [SAVE_STOCK_REVISION_COUNTS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${PATH}/${payload.id}/counts`, { counts: payload.counts })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [ACCEPT_STOCK_REVISION_DEFAULT_COUNTS](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/accept-default-counts`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [FINALIZE_STOCK_REVISION](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/finalize`)
        .then(({ data }) => resolve({ revision: data.data, meta: data.meta || {} }))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [REOPEN_STOCK_REVISION](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/reopen`)
        .then(({ data }) => resolve({ revision: data.data, meta: data.meta || {} }))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [REOPEN_LATEST_STOCK_REVISION](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/reopen-latest`, params)
        .then(({ data }) => resolve({ revision: data.data, meta: data.meta || {} }))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_REVISION_ITEM_LOTS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/${payload.id}/items/${payload.itemId}/lots`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [SAVE_STOCK_REVISION_ITEM_LOTS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${PATH}/${payload.id}/items/${payload.itemId}/lots`, {
        lots: payload.lots,
      })
        .then(({ data }) => resolve({ breakdown: data.data, meta: data.meta || {} }))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
};
